import { useId } from 'react';
import { Checkbox, Label } from '@monksflow/monks-ui';

export interface ChecklistFieldValue {
  selected: string[];
}

export interface ChecklistFieldConfig {
  options?: string[];
  /** Accepted but ignored — checklist is always multi-select, per the type's own contract. */
  multiple?: boolean;
}

interface ChecklistFieldProps {
  value: ChecklistFieldValue | null;
  config: ChecklistFieldConfig;
  disabled?: boolean;
  onChange: (next: ChecklistFieldValue) => void;
}

/** Pure, controlled. Always multi-select — `config.multiple` (shared with `select`) is ignored. */
export function ChecklistField({ value, config, disabled = false, onChange }: ChecklistFieldProps) {
  const options = config.options ?? [];
  const selected = value?.selected ?? [];
  const listId = useId();

  const toggle = (option: string, checked: boolean) => {
    const next = checked ? [...selected, option] : selected.filter((s) => s !== option);
    onChange({ selected: next });
  };

  return (
    <div className="flex flex-col gap-2">
      <div
        data-testid="brief-section-field-checklist-list"
        className="flex flex-col gap-2 rounded-md border border-border p-3"
      >
        {options.map((option, index) => {
          const id = `${listId}-${index.toString()}`;
          return (
            <div key={option} className="flex items-center gap-2">
              <Checkbox
                id={id}
                checked={selected.includes(option)}
                disabled={disabled}
                onCheckedChange={(checked: boolean | 'indeterminate') =>
                  toggle(option, checked === true)
                }
              />
              <Label htmlFor={id}>{option}</Label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
